//extracted by mini-css-extract-plugin
export default {"mailLogo":"styles_mailLogo__wPuw1","messageBox":"styles_messageBox__1kzo9","messageBody":"styles_messageBody__eAWEX","buttonContainer":"styles_buttonContainer__2PHFP"};;